import {
	deserializeDecisionMakers,
	deserializeDescription,
	deserializeLocation,
	deserializeMedia,
	deserializeScope,
	deserializeTags,
} from 'src/app/pages/petitionEditV2/shared/schemas';

import type { PetitionEditPageData } from '../../pageData';

import type { PetitionEditPageState } from './types';

export function initialState({ petition }: PetitionEditPageData): PetitionEditPageState {
	return {
		id: petition.id,
		formState: {
			ask: {
				value: petition.ask,
				error: null,
				dirty: false,
			},
			description: deserializeDescription({ petition }),
			geoReach: deserializeScope({ petition }),
			decisionMakers: deserializeDecisionMakers({ petition }),
			media: deserializeMedia({ petition }),
			tags: deserializeTags({ petition }),
			relevantLocation: deserializeLocation({ petition }),
		},
		uploader: null,
		saveFormError: null,
	};
}
